import convert from 'color-convert';

const START_HUE = 150;
const SATURATION = 80;
const LIGHTNESS = 50;
const HUE_OFFSET = 50;
const SATURATIN_OFFSET = 10;
const LIGHTNESS_OFFSET = 25;

const sourceColorMap = {
    android: 'rgba(164,198,57,1)',
    ios: 'rgba(100,100,100,1)',
    web: 'rgb(116,142,215)',
    mobile: 'rgb(175,190,232)',
};

const getColorRGB = (h, s, l) => convert.hsl.rgb(h % 360, s, l);
const getColorString = (rgbArray, opacity) => `rgba(${rgbArray[0]}, ${rgbArray[1]}, ${rgbArray[2]}, ${opacity})`;

const getPrimaryColor = opacity => `rgba(0, 124, 252, ${opacity})`;

const getColor = (key, opacity, deafultColor) => (deafultColor ? getPrimaryColor(opacity)
    : getColorString(
        getColorRGB(
            (START_HUE + (Number(key) * HUE_OFFSET)),
            SATURATION + (((Number(key) + 2) % 2) * SATURATIN_OFFSET),
            LIGHTNESS + (((Number(key) + 2) % 2) * LIGHTNESS_OFFSET),
        ),
        opacity,
    )
);

const getSourceColor = source => sourceColorMap[source];

export { getColor, getSourceColor };

export default getColor;
